









import Vue from 'vue'
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options'
import { Action } from '@/requests/mainApi'

interface Data {}

interface Methods {}

interface Computed {}

interface Props {
  actionModel: Action
}

export default Vue.extend({
  name: 'ActionsCard',
  props: {
    actionModel: {
      type: Object,
      default: {}
    }
  },
  computed: {
    tillDate () {
      const date = new Date(this.actionModel.dateTo || '')
      return this.$t(`app.profile.actions.dates.${date.getMonth()}`,
        {
          day: date.getDate(),
          year: date.getFullYear()
        }
      )
    }
  }
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>)
